import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { CampaignGoalTypeBoostV2 } from '@bingads-webui-campaign-react/campaign-onboarding-v2';

export const CampaignGoal = ({ campaign }) => {
  const CampaignGoali18nMap = CampaignGoalTypeBoostV2;

  const campaignGoalText = _.result(
    _.find(campaign.CampaignSettings, i => _.has(i, 'CampaignObjectiveSettingType')),
    'CampaignObjectiveSettingType'
  );

  return _.has(CampaignGoali18nMap, campaignGoalText) ? (
    <span>{CampaignGoali18nMap[campaignGoalText]}</span>
  ) : <span>{_TL_('Campaign goal not set')}</span>;
};

CampaignGoal.propTypes = {
  campaign: PropTypes.shape({
    CampaignSettings: PropTypes.shape([]).isRequired,
  }).isRequired,
};
